<template>
  <div class="body d-flex py-lg-3 py-md-2">
    <div class="container-xxl">
      <div class="row clearfix">
        <div class="col-md-12">
          <div class="card border-0 no-bg">
            <div class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between main-button-area">
            <!-- Year Filter Dropdown -->
<div class="d-flex align-items-center wx-year-filter">
  <label class="me-2 mb-0 wx-filter-label">Select Year:</label>
  <select class="form-select w-auto" v-model="selectedYear" @change="updateYearFilter">
    <option value="">All</option>
    <option v-for="year in yearOptions" :key="year" :value="year">{{ year }}</option>
  </select>
</div>
            <div class="col-auto d-flex">
              <button type="button" class="ms-0 ms-sm-3 btn btn-dark" style="color:var(--secondary-color); font-weight:bold" @click.prevent="createRequest" v-if="canCreateDayOff || superUser">
                <i class="icofont-plus me-2 fs-6"></i>Request Days Off
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row clearfix">
        <!-- daysoff Table -->
        <div class="col-lg-6 col-md-12">
          <div class="card">
            <div class="card-body table-responsive" style="width: 95%; margin: 0 auto">
              
              <table id="myProjectTable" class="table table-hover align-middle mb-0 mis_table" style="width: 100%">
                <thead>
                  <tr>
                    <th style="width:12%;" v-if="superUser || canViewAllDaysOff">
                      <div  class="d-flex align-items-center">
                        <select class="ms-1 nav-link rounded" name="" id="dropdownManagers"
                          @change="updateManagerFilter">
                          <option value="" selected>Name</option>
                          <option v-for="manager in managers" :key="manager.id"
                              :value="manager.id">
                              {{ manager.username }}
                          </option>
                        </select>
                        
                      </div>
                    </th>
                    <th style="width:15%;"><div>Dates</div></th>
                    <th style="width:15%;"><div>Type</div></th>
                    <th style="width:12%;"><div>Reason</div></th>
                    <th style="width:6%;"><div>Days</div></th>
                    <th style="width:6%;"><div>Accepted</div></th>
                    <th style="width:6%; background-color:white; border:none" class="no-after"><div></div></th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for="(daysoff, index) in data" :key="daysoff.id" :class="{ 'approved': daysoff.approved === 1, 'not-approved': daysoff.approved === 0 }" >
                    <td v-if="superUser || canViewAllDaysOff">{{ daysoff.user?.username }}</td>
                    <td>{{ daysoff.from_formatted }} {{ daysoff.to_formatted }}</td>
                    <td>{{ daysoff?.kind?.title }}</td>
                    <td>{{ daysoff.description }}</td>
                    <td>{{ daysoff.days }}</td>
                    <td>
                      <button type="button" class="btn btn-secondary ms-3" v-if="daysoff.approved">
                        <i v-if="daysoff.approved === 1" class="icofont-ui-check text-white"></i>
                        <i v-if="daysoff.approved === 0" class="icofont-ui-close text-white"></i>
                      </button>
                    </td>                    <td>
                      <button v-if="superUser || canEditDayOff" type="button" class="btn btn-secondary deleterow" @click="removeDayOff(daysoff.id)">
                        <i class="icofont-ui-delete text-white"></i>
                      </button>
                    </td>
                  </tr>
                  <tr class="col" v-if="!data || !data.length">
                          <td colspan="100">No data</td>


                        </tr>
                </tbody>
              </table>
              <nav aria-label="Page navigation" v-if="data && data.length">
                <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                  <li class="page-item" v-for="(paginationLink, index) in paginationLinks" :key="index" :class="{ active: paginationLink.active }">
                    <router-link :to="{ path: 'days-off', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }" v-if="paginationLink.url">
                      <span class="page-link" v-html="paginationLink.label"></span>
                    </router-link>
                    <span class="page-link" v-else v-html="paginationLink.label"></span>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="card-body table-responsive" style="width: 95%; margin: 0 auto">
              <div class="d-flex justify-content-between align-items-center mb-3">
    <h3 class="m-0">Other Requests</h3>
    <button type="button" class="ms-0 ms-sm-3 btn btn-dark" style="color:var(--secondary-color); font-weight:bold" @click.prevent="createOtherRequest" v-if="canCreateDayOff || superUser"> 
      <i class="icofont-plus me-2 fs-6"></i>Request 
    </button>
  </div>
              <table id="myProjectTable" class="table table-hover align-middle mb-0 mis_table" style="width: 100%">
                <thead>
                  <tr>
                    <th style="width:12%;" v-if="superUser || canViewAllDaysOff">
                      <div  class="d-flex align-items-center">
                        <select class="ms-1 nav-link rounded" name="" id="dropdownManagers"
                          @change="updateManagerFilter">
                          <option value="" selected>Name</option>
                          <option v-for="manager in managers" :key="manager.id"
                              :value="manager.id">
                              {{ manager.username }}
                          </option>
                        </select>
                        
                      </div>
                    </th>
                    <th style="width:15%;"><div>Date</div></th>
                    <th style="width:12%;"><div>From</div></th>
                    <th style="width:12%;"><div>To</div></th>
                    <th style="width:12%;"><div>Reason</div></th>
                    <th style="width:12%;"><div>Accepted</div></th>
                    <th style="width:6%; background-color:white; border:none" class="no-after"><div></div></th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for="(other_request, index) in otherRequestsList" :key="other_request.id" :class="{ 'approved': other_request.approved === 1, 'not-approved': other_request.approved === 0 }">
                    <td v-if="superUser || canViewAllDaysOff">{{ other_request.user?.username }}</td>
                    <td>{{ other_request.request_date_formatted }}</td>
                    <td>{{ other_request.from_time }}</td>
                    <td>{{ other_request.to_time }}</td>

                    <td>{{ other_request.description }}</td>
                    <td>
                      <button type="button" class="btn btn-secondary deleterow" v-if="other_request.approved">
                        <i v-if="other_request.approved === 1" class="icofont-ui-check text-white"></i>
                        <i v-if="other_request.approved === 0" class="icofont-ui-close text-white"></i>
                      </button>
                    </td>                    <td>
                      <button v-if="superUser || canEditDayOff" type="button" class="btn btn-secondary deleterow" @click="removeOtherRequest(other_request.id)">
                        <i class="icofont-ui-delete text-white"></i>
                      </button>
                    </td>
                  </tr>
                  <tr class="col" v-if="!otherRequestsList || !otherRequestsList.length">
                    <td colspan="100">No data</td>
                  </tr>
                </tbody>
              </table>
              <nav aria-label="Page navigation" v-if="otherRequestsEvents && otherRequestsEvents.length">
                <ul class="pagination mt-4" v-if="otherRequestsPaginationLinks && otherRequestsPaginationLinks.length > 0">
  <li class="page-item"
      v-for="(paginationLink, index) in otherRequestsPaginationLinks"
      :key="index"
      :class="{ active: paginationLink.active }">
    <a class="page-link"
       v-if="paginationLink.url"
       @click.prevent="changeOtherRequestsPage(paginationLink.url)">
       <span v-html="paginationLink.label"></span>
    </a>
    <span class="page-link" v-else v-html="paginationLink.label"></span>
  </li>
</ul>


              </nav>
            </div>
          </div>
        </div>
        <!-- Calendar -->
        <div class="col-lg-6 col-md-12">
          <div class="card">
            <div class="card-body calendar-container">
              

              <FullCalendar ref="fullCalendar" :options="calendarOptions" />
              <div class="d-flex justify-content-start mt-3">
  <div class="color-legend">
    <span class="legend-item">
      <span class="legend-color" style="background-color: rgb(153, 237, 195);"></span> Days Off
    </span>
    <span class="legend-item">
      <span class="legend-color" style="background-color: red;"></span> Other Requests
    </span>
  </div>
</div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <!-- Add Event -->
      <div class="modal fade" id="create-daysoff-form" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold" id="createprojectLabel">Request Days Off</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <input name="id" id="id" type="hidden" v-model="daysoffData.id" />
              <div class="deadline-form">
                <div class="row g-3 mb-1">
                  <div class="col">
    <label for="from" class="form-label">Start Date</label>
    <input
      type="date"
      class="form-control"
      id="from"
      v-model="daysoffData.from"
      :min="today" 
      placeholder="Start Date"
    />
  </div>
                  <div class="col">
                    <label for="to" class="form-label">End Date</label>
                    <input type="date" class="form-control" id="to" v-model="daysoffData.to" placeholder="End Date" :min="daysoffData.from || today" >
                  </div>
                </div>
              </div>
              <div class="mb-1">
                <label for="description" class="form-label">Reason</label>
                <textarea class="form-control" id="description" rows="3" v-model="daysoffData.description" placeholder="Reason"></textarea>
              </div>
            </div>
            <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="submitForm">Save</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="create-other_request-form" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title fw-bold" id="createprojectLabel">Request</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <input name="id" id="id" type="hidden" v-model="otherRequestForm.id" />
                <div class="deadline-form">
                    <div class="row g-3 mb-1">
                        <div class="col">
                            <label for="from" class="form-label">Date</label>
                            <input
                                type="date"
                                class="form-control"
                                id="from"
                                v-model="otherRequestForm.request_date"
                                :min="today"
                                placeholder="Date"
                            />
                        </div>
                    </div>

                    <!-- Time Fields (From and To) -->
                    <div class="row g-3 mb-1">
                        <div class="col">
                            <label for="from_time" class="form-label">From (Time)</label>
                            <input
                                type="time"
                                class="form-control"
                                id="from"
                                v-model="otherRequestForm.from"
                                placeholder="From Time"
                            />
                        </div>
                        <div class="col">
                            <label for="to_time" class="form-label">To (Time)</label>
                            <input
                                type="time"
                                class="form-control"
                                id="to"
                                v-model="otherRequestForm.to"
                                placeholder="To Time"
                            />
                        </div>
                    </div>
                </div>

                <div class="mb-1">
                    <label for="description" class="form-label">Reason</label>
                    <textarea class="form-control" id="description" rows="3" v-model="otherRequestForm.description" placeholder="Reason"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="submitOtherRequest">Save</button>
            </div>
        </div>
    </div>
</div>

    </div>
  </div>
  
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useFetchData } from '@/composables/useFetchData';
import { fetchAll, createOrUpdate, deleteDayOff } from '@/services/daysoff'; 
import { fetchOtherRequests, createOrUpdateOtherRequest, deleteOtherRequest } from '@/services/other-requests'; 
import { useToast } from 'vue-toastification';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import { mapGetters } from 'vuex';
import { fetchManagers } from '@/services/followup';

const defaultdaysoffData = {
  id: '',
  user: '',
  from: '',
  to: '',
  description: ''
};

const defaultOtherRequestsData = {
  id: '',
  user: '',
  request_date: '',
  from: '',
  to: '',
  description: ''
};


const prepareDaysOffData = function(data) {
  if (!Array.isArray(data)) {
    console.error('Expected an array, but received:', data); // Debugging log
    return []; // Return an empty array if data is not an array
  }

  const today = new Date().toISOString().slice(0, 10);

  // Filter out days off requests that are not approved
  const approvedDaysOff = data.filter(daysoff => daysoff.approved === 1);

  return approvedDaysOff.map(daysoff => {
    const startDate = new Date(daysoff.from);
    const endDate = new Date(daysoff.to);
    endDate.setDate(endDate.getDate() + 1); // FullCalendar's end date is exclusive, so we add one day

    return {
      id: daysoff.id,
      title: '', // Empty title, since we're using description instead
      start: startDate.toISOString().slice(0, 10),
      end: endDate.toISOString().slice(0, 10),
      isToday: daysoff.from === today || daysoff.to === today, // Check if any of the start or end dates are today
      description: daysoff.description, // Include description
      user: daysoff.user.username // Include user.username
    };
  });
};


const prepareOtherRequestsData = function(data) {
  if (!Array.isArray(data)) {
    console.error('Expected an array, but received:', data);
    return [];
  }

  const today = new Date().toISOString().slice(0, 10);

  // Filter out requests that are not approved
  const approvedRequests = data.filter(req => req.approved === 1);

  return approvedRequests.map(req => {
    const startDate = new Date(req.request_date);
    const endDate = new Date(req.request_date);
    endDate.setDate(endDate.getDate() + 1); // FullCalendar's end date is exclusive, so we add one day
    return {
      id: req.id,
      title: '', // Empty title, since we're using description instead
      start: startDate.toISOString().slice(0, 10),
      end: endDate.toISOString().slice(0, 10),
      from: req.from_time,
      to: req.to_time,
      isToday: req.request_date === today,
      description: req.description, // Include description
      user: req.user.username, // Include user.username
      type: 'otherRequest' // Mark as other request type
    };
  });
};

export default {
  name: 'DaysOff',
  components: {
    FullCalendar
  },
  methods: {
        
        canEditDayOff(dayoff) {
            if (!dayoff) { return false; }
            return localStorage.getItem('current_user_id') == dayoff?.createdBy && this.userPermissions?.edit === 1;
        },
       
    },
  computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission',

        }),
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        userPermissions() {
            return this.getUserPermission('Days off');
        },
        canEditDayOff() {
            return this.userPermissions?.editCreator === 1;
        },
        canEditAllDaysOff() {
            return this.userPermissions?.editAll === 1;
        },
        canViewAllDaysOff() {
            return this.userPermissions?.viewAdmin === 1;
        },
        canCreateDayOff() {
            return this.userPermissions?.create === 1;
        },
        canArchive() {
            return this.userPermissions?.archive === 1;
        },
    },
  setup() {
    const route = useRoute();
    const toast = useToast();

    const { data, paginationLinks, filters, updateFilters, fetchData } = useFetchData(fetchAll, { page: route.query.page || 1,  year: route.query.year || ''}, { page: 1 });

    const daysoffData = ref(defaultdaysoffData);
    const otherRequestsList = ref([]);
const otherRequestForm = ref({ ...defaultOtherRequestsData });
    
    const otherRequestsPage = ref(1);
const otherRequestsPaginationLinks = ref([]);

    const daysoffEvents = ref([]);
const otherRequestsEvents = ref([]);
const calendarEvents = ref([]);

    const managers = ref([]);

    const today = new Date().toISOString().slice(0, 10);

    const currentYear = new Date().getFullYear();
const yearOptions = ref([
  currentYear,
  currentYear - 1,
  currentYear - 2,
  currentYear - 3
]);
const selectedYear = ref(route.query.year || '');

const updateYearFilter = () => {
  updateFilters({
    ...filters.value,
    year: selectedYear.value,
    page: 1
  });

  (async () => {
    await fetchDaysOff();             // Refresh days off
    await fetchOtherRequestsData();   // ✅ Refresh other requests using year filter
  })();
};


    // Update createRequest function to reset daysoffData
    const createRequest = () => {
      daysoffData.value = { ...defaultdaysoffData };
      $('#create-daysoff-form').modal('toggle');
    };

    const createOtherRequest  = () => {
      otherRequestForm.value = { ...defaultOtherRequestsData };
      
      $('#create-other_request-form').modal('toggle');
    };

    // Update deleteDayOff function to use the correct service function
    const removeDayOff = async (id) => {
      const response = await deleteDayOff({ id });
      if (response.data.success) {
        toast.success(response.data.message);
        fetchData();
      } else {
        toast.error(response.data.message);
      }
    };

    const removeOtherRequest = async (id) => {
      const response = await deleteOtherRequest({ id });
      if (response.data.success) {
        toast.success(response.data.message);
        fetchOtherRequestsData();
      } else {
        toast.error(response.data.message);
      }
    };

    const fetchManagersData = async () => {
            try {
                const response = await fetchManagers();
                if (response.data.success) {
                    managers.value = response.data.data;
                }
            } catch (error) {
                console.error('Failed to fetch managers:', error);
            }
        };

        const updateManagerFilter = (event) => {
            const newManagerId = event.target.value;
            updateFilters({ ...filters.value, userFilter: newManagerId, page: 1 });
        };

    // Update submitForm function to use the correct service function
    const submitForm = async () => {
      try {
        const response = await createOrUpdate(daysoffData.value);
        if (response.data.success) {
          toast.success(response.data.message);
          $('#create-daysoff-form').modal('toggle');
          fetchData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error(error);
      }
    };

    const submitOtherRequest = async () => {
      try {
        const response = await createOrUpdateOtherRequest(otherRequestForm.value);
        if (response.data.success) {
          toast.success(response.data.message);
          $('#create-other_request-form').modal('toggle');
          fetchOtherRequestsData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error(error);
      }
    };

    const getPageFromUrl = (url) => {
      if (!url) return null;
      const urlObj = new URL(url, window.location.origin);
      return urlObj.searchParams.get('page');
    };

    const changeOtherRequestsPage = (url) => {
  const page = getPageFromUrl(url);
  if (page) {
    otherRequestsPage.value = page;
    fetchOtherRequestsData();
  }
};


    const fetchDaysOff = async () => {
  try {
    const response = await fetchAll({ year: selectedYear.value });
    if (response.data.success) {
      daysoffEvents.value = prepareDaysOffData(response.data.data.data);
      mergeCalendarEvents();
    }
  } catch (error) {
    console.error('Error fetching daysoff:', error);
  }
};


const fetchOtherRequestsData = async () => {
  try {
    const response = await fetchOtherRequests({ page: otherRequestsPage.value, year: selectedYear.value });
    if (response?.data?.success) {
      otherRequestsList.value = response.data.data.data;
      otherRequestsPaginationLinks.value = response.data.data.links;

      otherRequestsEvents.value = prepareOtherRequestsData(response.data.data.data);
      mergeCalendarEvents();
    }
  } catch (error) {
    console.error('Error fetching other requests:', error);
  }
};


const mergeCalendarEvents = () => {
  calendarEvents.value = [...daysoffEvents.value, ...otherRequestsEvents.value];
};


const calendarOptions = computed(() => ({
  plugins: [dayGridPlugin],
  initialView: 'dayGridMonth',
  events: calendarEvents.value,
  eventContent: function(arg) {
    const description = arg.event.extendedProps.description; // Access description property
    const username = arg.event.extendedProps.user; // Access user property
    const eventType = arg.event.extendedProps.type; // Access the event type
    const isToday = arg.event.extendedProps.isToday; // Check if it is today's event
    const from_time = arg.event.extendedProps.from; // Access the start date
    const to_time = arg.event.extendedProps.to; // Access the end date

    let eventStyle = '';

    // Apply red background for other requests
    if (eventType === 'otherRequest') {
      eventStyle = 'background-color: red; color: white;';
      // Change the event label to show "username (from to)"
      return {
        html: `<div class="fc-event-title" style="${eventStyle}" title="${from_time} to ${to_time}">
                  ${username} (${from_time} to ${to_time})
                </div>`
      };
    } else {
      eventStyle = 'background-color: rgb(153, 237, 195); color: white;';
    }

    

    // Return the event content with the applied styles
    return {
      html: `<div class="fc-event-title" style="${eventStyle}" title="${description}">
                ${username} (${description})
              </div>`
    };
  }
}));

    onMounted(async () => {
      await fetchData(); // Fetch data for the table
      await fetchDaysOff(); // Fetch data for the calendar
      await fetchOtherRequestsData(); // Fetch data for the calendar
      fetchManagersData();

    });

    return {
      data,
      paginationLinks,
      filters,
      updateFilters,
      fetchData,
      daysoffData,
      getPageFromUrl,  
  otherRequestsPaginationLinks,
  changeOtherRequestsPage,
      submitForm,submitOtherRequest,
      createRequest,
      createOtherRequest,
      removeDayOff,
      calendarOptions,
      updateManagerFilter, managers,
      today,otherRequestsList,
      otherRequestForm, removeOtherRequest, otherRequestsEvents, selectedYear,
  yearOptions,
  updateYearFilter
    };
  },
  metaInfo: {
    title: 'Days Off',
    meta: [
      { name: 'description', content: 'MIS - Days Off' },
      { property: 'og:title', content: 'MIS - Days Off' },
      { property: 'og:description', content: 'This is the days off page.' }
    ]
  }
};
</script>

<style scoped>
.calendar-container {
  height: 1000px; /* Adjust this height as needed */
  overflow: auto;
}

.fc-event-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fc-event-title:hover {
  white-space: normal;
}
.color-legend {
  display: flex;
  align-items: center;
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.legend-color {
  width: 15px;
  height: 15px;
  border-radius: 3px; /* Optional: makes it rounded */
}

</style>
